<template>
  <div ref="dropdownProgramContent">
    <!--content-->
    <div class="flex justify-center pb-4 mt-4">
      <div class="flex max-w-7xl ">
        <!--first Div-->

        <div class="shadow-2xl py-2 w-[15rem] lg:w-[20rem] rounded-lg">
          <h2 class="text-[#001C54] font-semibold text-start text-lg px-2 pb-2">
            Browse by Programs
          </h2>
          <div class="flex justify-between py-2 cursor-pointer" v-for="data in navElectives" :key="data.id"
            @click="navProgramInfo(data.id), changeElecBg(data.name), isCertificateMenuEnabled = false"
            :class="navElectivesBg == data.name ? 'bg-[#efefef]' : ''">
            <h3 class="font-bold text-[#001C54] text-md lg:text-base px-2">
              {{ data.name }}
            </h3>
            <div class="px-2">
              <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
            </div>
          </div>
          <!-- <div class="flex justify-between py-2 cursor-pointer"
            @click="isCertificateMenuEnabled = true, navProgramInfo(0), changeElecBg('certification')"
            :class="isCertificateMenuEnabled ? 'bg-[#efefef]' : ''">
            <h3 class="font-bold text-[#001C54]  text-md lg:text-base px-2">
              Certifications
            </h3>
            <div class="px-2">
              <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
            </div>
          </div> -->
        </div>

        <!--first Div-->
        <!--Seconde-Div-->
        <div v-if="!isCertificateMenuEnabled" class="mt-[2rem] pl-4 flex">
          <!--category-->
          <div
            class="shadow-2xl rounded-lg w-[13rem] xl:w-[20rem] flex flex-col text-start text-[#001C54] cursor-pointer">
            <div v-for="course in navPrograms" :key="course.id">
              <div class="p-2 py-4 font-semibold text-md cursor-pointer flex justify-between" @click="
                navCourseInfo(course.id),
                changeProgramBg(course.short_name)
                " :class="navProgramsBg == course.short_name ? 'bg-[#efefef]' : ''
                  ">
                <span>{{ course.short_name }}</span>
                <span>
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
                </span>
              </div>
            </div>
          </div>
          <!--category-->
          <!--categoryContent-->
          <div>
            <div class="mb-2" v-for="content in navCourses.slice(0, 1)" :key="content.id">
              <h2 class="pl-4 text-left">
                <a :href="`/${content.program.slug}`" class="bg-[#001c54] p-1 rounded-3xl px-3 py-2">
                  <span class="text-[#F8C300]">
                    Online {{ content.program.short_name }}
                  </span>
                </a>
              </h2>
            </div>

            <div
              class="p-2 pl-4 pt-0 grid grid-flow-row auto-rows-max row-gap-1 w-[18rem] lg:w-[20rem] xl:w-[23rem] 2xl:w-[35rem] h-[22rem] overflow-y-auto">
              <!-- Loop through all navCourses -->
              <div v-for="content in navCourses" :key="content.id">
                <a :href="`/${content.program.short_slug}/${content.slug}`">
                  <div class="text-start w-full p-[0.2rem] flex flex-col justify-between">
                    <h2 class="text-[#001C54] text-lg font-semibold line-clamp-2">
                      {{ content.name }}
                    </h2>
                  </div>
                </a>
              </div>

              <!-- Show AI-Driven electives if any course is for MBA -->
              <template v-if="navCourses.some(item => item.program.short_name === 'MBA')">
                <div
                  v-for="title in ['AI-Driven Finance', 'AI-Driven Digital Marketing', 'AI-Driven Business Strategy']"
                  :key="title" class="text-start w-full p-[0.2rem] flex flex-col justify-between cursor-not-allowed">
                  <h2 class="text-[#001C54] text-lg font-semibold line-clamp-2">
                    {{ title }}
                  </h2>
                </div>
              </template>
            </div>
            <a href="/all-programs">
              <div class="ml-auto mr-10 w-max bg-[#F8C300] mt-4 p-3 rounded-full font-bold cursor-pointer">
                Explore All Programs
              </div>
            </a>
          </div>
          <!--categoryContent-->
        </div>

        <div v-if="isCertificateMenuEnabled" class="mt-[2rem] pl-4 flex">
          <div>
            <div class="mb-0" v-for="content in navCourses.slice(0, 1)" :key="content.id">
              <h2 class="flex items-center pl-4 text-left">
                <div class=" bg-[#001c54] p-1 rounded-3xl px-3 py-2">
                  <span class="text-[#F8C300]">
                    Online Certification
                  </span>
                </div>
                &nbsp;Programs Offered
              </h2>
            </div>

            <div
              class="p-2  pl-4 pt-0 grid grid-flow-row auto-rows-max row-gap-1 w-[18rem] lg:w-[40rem] xl:w-[43rem] 2xl:w-[55rem] h-[22rem] overflow-y-auto">
              <div>
                <a href="/genai-certification">
                  <div class="text-start w-full p-[0.2rem] flex flex-col justify-between">
                    <h2 class="text-[#001C54] text-lg font-semibold line-clamp-2">
                      Generative AI Certificate Program
                    </h2>
                  </div>
                </a>
              </div>
            </div>
            <a href="/all-programs">
              <div class="ml-auto mr-10 w-max bg-[#F8C300] mt-4 p-3 rounded-full font-bold cursor-pointer">
                Explore All Programs
              </div>
            </a>
          </div>
        </div>
      </div>

    </div>
    <!--content-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCertificateMenuEnabled: false
    }
  },
  props: [
    "navElectives",
    "navPrograms",
    "navCourses",
    "navProgramInfo",
    "navCourseInfo",
    "changeElecBg",
    "changeProgramBg",
    "navElectivesBg",
    "navProgramsBg",
    "navProgramsBg",
    "courseBgMob"
  ],
  methods: {

  }
};
</script>

<style scoped>
.dropdown {
  background: white;
  border: 1px solid #ccc;
  position: absolute;
}
</style>